import React from 'react'

export default function Testimonials() {
  return (
    <div className='testimonial'>
      <h1>Going to Add Testimonials soon...</h1>
    </div>
  )
}
